import { GridColDef } from '@mui/x-data-grid';
import Table from '../custom/Table';
import Title from '../custom/Title';
import DynamicForm from '../forms/DynamicForm';
import { PAYMENT_BLOTTER_FIELDS, SEARCH_PAYMENT_BLOTTER_FIELDS } from '../../Models/BlotterTables';


export const PaymentBlotter = () => {

    const config = SEARCH_PAYMENT_BLOTTER_FIELDS

    const getPaymentBlotterColumns = (): GridColDef<any>[] => {
        let minWidth = 100
        return PAYMENT_BLOTTER_FIELDS.map(inboundField => {
            switch (inboundField.id) {
                case "amountNumber":
                    minWidth = 160
                    break;
                case "customerName":
                    minWidth = 150
                    break;
                case "beneficiaryName":
                    minWidth = 150
                    break;
                case "transactionType":
                    minWidth = 150
                    break;
                case "dgTxnRefNo":
                    minWidth = 180
                    break;
                case "paymentPartner":
                    minWidth = 160
                    break;

                default:
                    minWidth = 100
                    break;
            }

            return {
                field: inboundField.id,
                headerName: inboundField.label,
                minWidth
            }
        })
    }

    const PaymentBlotterRows = [{ id: 1 }]
    const submitHandler = (data: any): any => {
        console.log(data)
    }
    return (
        <div style={{ padding: '0 10px' }}>
            <div style={{ borderBottom: '1px solid #d8d8d8' }}>
                <Title style={{ textAlign: 'left', margin: '20px 10px 10px 10px', color: '#7f7d76' }}>Payment Blotter</Title>
            </div>
            <div style={{ padding: '20px 0px' }}>
                <DynamicForm config={config} onSubmit={submitHandler} submitText='Search' onCancel={() => { }} cancelText='Clear Filter' />
            </div>
            <Table columns={getPaymentBlotterColumns()} rows={PaymentBlotterRows} />
        </div>
    )
}
